export default {
  namespaced: true,
  installation_components: {
    next: "Siguiente",
    previous: "Anterior",
    no_options_found: "No se encontraron, opciones",
  },
};
